"use strict";
var Observable_1 = require('../../Observable');
var sample_1 = require('../../operator/sample');
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/service_tracking/web/service_tracking/~/rxjs/add/operator/sample.js
// module id = ../../../../rxjs/add/operator/sample.js
// module chunks = 3